import { editorContentShiftViewState } from "../..";
import { Moment } from "moment";
import { mutatorAction } from "satcheljs";

export default mutatorAction("updateSelectedTimeMapShift", function updateSelectedTimeMapShift(id: string, selectedTime: Moment) {
    if (editorContentShiftViewState() && editorContentShiftViewState().selectedTimeMap) {
        editorContentShiftViewState().selectedTimeMap.set(id, selectedTime);
    }
});